module.exports = __webpack_public_path__ + "img/vc.d3c9e65b.svg";